const calculateBarChartMinWidth = (numberOfBarsInEachGroup: number, numberOfGroups: number) => {
    const barWidth = 21;
    const spaceBetweenGroups = 20;
    const approximateYAxisUiSize = 100;

    const groupSize = barWidth * numberOfBarsInEachGroup + spaceBetweenGroups;
    const minWidth = Math.floor(groupSize * numberOfGroups + approximateYAxisUiSize);

    return minWidth;
};

export default calculateBarChartMinWidth;
